import PostsUserPage from 'flarum/forum/components/PostsUserPage';
/**
 * The `MentionsUserPage` component shows post which user Mentioned at
 */
export default class MentionsUserPage extends PostsUserPage {
  params(user) {
    return {
      filter: {
        type: 'comment',
        mentioned: user.id()
      }
    };
  }
}
flarum.reg.add('flarum-mentions', 'forum/components/MentionsUserPage', MentionsUserPage);